/**
 *
 * @Pattern https://mgechev.github.io/angularjs-in-patterns/#facade
 */

export default function Users(
    UserService,
    UserModel,
    UserStorage,
    CompanyModel,
    PspModel,
    $q,
    Auth
) {
    var fn = this;

    // init

    fn.access = {
        OK: 200,

        // "we don't know who you are, so we can't say if you're authorized to access
        // this resource or not yet, please sign in first"
        UNAUTHORIZED: 401,

        // "we know who you are, and your profile does not allow you to access this resource"
        FORBIDDEN: 403,
    };

    fn.Model = () => {
        return angular.copy(UserModel); // do not allow the model itself to be changed
    };

    fn.CompanyModel = () => {
        return angular.copy(CompanyModel); // do not allow the model itself to be changed
    };

    fn.PspModel = () => {
        return angular.copy(PspModel); // do not allow the model itself to be changed
    };

    fn.getCurrentUser = () => {
        return Auth.getProfile().then(
            (profile) => {
                return profile;
            },
            () => {
                return null;
            }
        );
    };

    fn.isAuthenticated = () => {
        return Auth.getProfileId().then(
            (userId) => {
                return userId; // userId
            },
            (err) => {
                return $q.reject(fn.access.UNAUTHORIZED);
            }
        );
    };

    /**
     * will check if user is autheticated and do another api request to get expanded user
     */
    fn.getAuthenticatedUser = () => {
        return Auth.getProfileId().then(
            (userId) => {
                return UserService.get(userId).then(
                    (res) => {
                        return $q.resolve(res);
                    },
                    (err) => {
                        return $q.reject(fn.access.UNAUTHORIZED);
                    }
                );
            },
            (err) => {
                return $q.reject(fn.access.UNAUTHORIZED);
            }
        );
    };

    /**
     * API v3
     */

    fn.create = (user, company) => {
        return UserService.create(user, company);
    };

    fn.get = (id) => {
        return UserService.get(id);
    };

    fn.update = (user) => {
        return UserService.update(user);
    };

    fn.getCompanyInfo = (userId) => {
        return UserService.getCompanyInfo(userId);
    };
    fn.updateCompanyInfo = (userId, company) => {
        return UserService.updateCompanyInfo(userId, company);
    };

    fn.getPsp = (userId) => {
        return UserService.getPsp(userId);
    };
    fn.updatePsp = (userId, psp) => {
        return UserService.updatePsp(userId, psp);
    };

    fn.getBookings = (id) => {
        return UserService.getBookings(id);
    };

    // fn.getBookingPeriods = (id, start, end, locationId, activityId) => {
    //     return UserService.getBookingPeriods(
    //         id,
    //         start,
    //         end,
    //         locationId,
    //         activityId
    //     );
    // };

    fn.getLocations = (id) => {
        return UserService.getLocations(id);
    };

    fn.getUserRoles = (id) => {
        return UserService.getUserRoles(id);
    };

    fn.emailCheck = (email) => {
        return UserService.emailCheck(email);
    };

    fn.usernameCheck = (username) => {
        return UserService.usernameCheck(username);
    };

    fn.changePassword = (userID, pw) => {
        return UserService.changePassword(userID, pw);
    };

    fn.resetPasswordRequest = (email) => {
        return UserService.resetPasswordRequest(email);
    };

    fn.verifyUid = (uid) => {
        return UserService.verifyUid(uid);
    };

    fn.resetPassword = (uid, newPassword) => {
        return UserService.resetPassword(uid, newPassword);
    };

    fn.logout = () => {
        return Auth.logout();
    };

    fn.validatePSP = (psp) => {
        return UserService.validatePSP(psp);
    };

    // fn.createCompanyInfo = (id, company) => {
    //     UserService.createCompanyInfo(id, company);
    // };

    /**
     * STORAGE
     */
    // fn.getUserSwitchDetected = () => {
    //     return UserStorage.getUserSwitchDetected();
    // };

    // fn.setUserSwitchDetected = (bool) => {
    //     return UserStorage.setUserSwitchDetected(bool);
    // };

    return fn;
}
